export default function select( $box = '' ) {
  const $selects = $( '.js-select', $box );

  $.each( $selects, ( i, el ) => {
    const $container = $( el );
    const $select = $container.find( 'select' );

    const fn = function() {
      const $options = $select.find( 'option' );
      const options = [];
      let currentId = null;

      //$select.prop( 'disabled', true );

      $.each( $options, ( i2, el2 ) => {
        const value = el2.innerHTML;
        const item = { id: i2, value };

        if ( i2 === 0 || el2.selected ) {
          currentId = i2;
        }

        options.push( item );
      } );

      $container.webix_richselect( {
        options,
        value: currentId,
        yCount: 3,
        scroll: 'y',
        height: 51,
        on: {
          onChange: ( id ) => {
            $options.prop( 'selected', false );
            $options.eq( id ).prop( 'selected', true );
            $select.trigger('change');
          },
        },
      } );
      $select.on('refresh', function() {
        $container.find('.webix_view').remove();
        fn();
      })
    }
    fn();

  } );
}
